import Head from 'next/head';
import { Box, Container, Typography } from '@mui/material';
import { DashboardLayout } from '../dashboard-layout';
import 'firebase/compat/firestore';

import LocationCard from './LocationCard';

const AddLocation = ({locationId}) => (
  <>
    <Head>
      <title>
        Ajouter boutique
      </title>
    </Head>
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        py: 3
      }}
    >
      <Container maxWidth="md">
        <Typography
          sx={{ mb: 3 }}
          variant="h4"
        >
          Ajouter une nouvelle boutique
        </Typography>
        <LocationCard locationId={locationId} isUpdate={false}/>
        {/* <Box sx={{ mt: 3 }}>
          <OrdersFullPanel />
        </Box> */}
      </Container>
    </Box>
  </>
);

AddLocation.getLayout = (page) => (
  <DashboardLayout>
    {page}
  </DashboardLayout>
);

export default AddLocation;
